import { jsx as _jsx } from "react/jsx-runtime";
import { TableBody } from './TableBody';
export const TableFoot = ({ as = 'tfoot', ...rest }) => {
    return _jsx(TableBody, Object.assign({ as: as, role: as !== 'tfoot' ? 'rowgroup' : undefined }, rest), void 0);
};
